exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-hover[data-v-542ef4f8]:hover{color:#2198f0!important}", ""]);

// exports
